<template>
  <div :class="{ ShopSuccess: true, 'ShopSuccess--small': $mq != 'desktop' }">
    <div class="Container">
      <div class="Labels">
        <div class="Title">{{ $t('shop.success.title') }}</div>
        <div class="Text" v-if="lastTypeProduct != null">{{ $t(`shop.success.text_${lastTypeProduct}`) }}</div>
        <div class="Subtext" v-if="lastTypeProduct == 2">{{ $t(`shop.success.text_2_subtitle`) }}</div>
        <vv-button v-if="lastTypeProduct && lastTypeProduct != 0" :customClass="'primary-variant'" @click="goto('themeList')">{{ $t('shop.success.button_label') }}</vv-button>
      </div>

      <img v-if="lastTypeProduct == 0 || lastTypeProduct == null" src="@/assets/cart-paid.png" class="Asset" />
      <img v-if="lastTypeProduct == 1" src="@/assets/cart-masterclass-paid.png" class="Asset" />
      <img v-if="lastTypeProduct == 2" src="@/assets/cart-masterclass-bottle-paid.png" class="Asset" />
    </div>
    
  </div>
</template>

<script>
import VvButton from "@/components/common/VvButton.vue"
import { SET_HIGHEST_PRODUCT_TYPE } from '@/store/modules/shop/types'

export default {
  name: 'ShopSuccess',
  data() {
    return {
      lastTypeProduct: null
    }
  },
  components: {
    VvButton
  },
  methods: {
    goto(value) {
      this.$router.push({ name: value})
    }
  },
  mounted() {
    this.lastTypeProduct = this.$store.state.shop.lastTypeProduct ? parseInt(this.$store.state.shop.lastTypeProduct) : 0
    this.$store.commit(SET_HIGHEST_PRODUCT_TYPE, null)
  }
}
</script>

<style lang="scss" scoped>
.ShopSuccess {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 94px);

  .Container {
    display: flex;
    flex-direction: row;
    width: 75%;
    margin-top: 10px;

    .Labels {
      width: 100%;
      padding-right: 15px;
      box-sizing: border-box;

      .Title {
        font-weight: bold;
        font-size: 40px;
        margin-bottom: 40px;
      }

      .Text {
        font-size: 30px;
      }

      .Subtext {
        margin-top: 20px;
        font-size: 22px;
      }
    }

    .Asset {
      width: 50%;
      height: auto;
    }
  }

  &--small {
    height: calc(100% - 53px);

    .Container {
      width: 100%;
      box-sizing: border-box;
      padding: 0 10px;
      flex-direction: column;

      .Labels {
        margin-top: 20px;
        .Title {
          font-weight: bold;
          font-size: 30px;
          margin-bottom: 20px;
        }
        .Text {
          font-size: 24px;
        }
        .Subtext {
          margin-top: 20px;
          font-size: 16px;
        }
      }
      .Asset {
        width: 75%;
        height: auto;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
}

button {
  margin-top: 30px;
}
</style>